import { take, map } from 'rxjs/operators';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs';

import { SharedSolaceStreamService } from 'src/solace';

import { BootstrapService, MarketService } from 'src/core';

import { AppState } from 'src/app';

import { ForeignExchangeRow } from './foreignexchange.class';

import { BADRESP } from 'dns';

@Component({
  selector: 'hb-foreignexchange',
  templateUrl: './foreignexchange.component.html',
  styleUrls: ['./foreignexchange.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ForeignExchangeComponent implements OnInit, OnDestroy {
  @Input() public foreignexchange: string;
  @Input() orientation = 'vertical';
  bootstrapPromise: Promise<any>;

  currentIndex = 'Euro';
  foreignexchanges: any[] = [];
  foreignexchangesMXN: any[] = [];
  foreignexchangesUSD: any[] = [];
  foreignexchangesUSDLeft: any[] = [];
  foreignexchangesUSDRight: any[] = [];
  foreignexchangesMXNAlways: any[] = [];

  mxnReferences: any;
  foreignExchangeData: any[] = [];

  indexSubscription: Subscription;

  skeleton = true;

  private consumerId = 'currency';
  private marketName = 'currencies';
  private operationTime: any;

  private mainMxnReferences = 'PESO MXN';

  private usdForeignExchanges: string[] = [
    'PESO MXN',
    'EURO',
    'POUND',
    'YEN',
    'REAL',
    'CANADA DLL',
    'RENMINBI CHINO',
    'CHILE',
    'LIRA TURCA',
    'RUBLO RUSO',
    'RUPIAH INDONESIA',
    'RUPEE INDIA',
    'PESO COLOMBIANO',
    'ARGENTINA',
  ];

  private usdForeignExchangeNames: string[] = [
    'PESO MXN',
    'EURO',
    'LIBRA',
    'YEN',
    'REAL',
    'DOLAR CANADIENSE',
    'RENMINBI CHINO',
    'PESO CHILENO',
    'LIRA TURCA',
    'RUBLO RUSO',
    'RUPIAH INDONESIA',
    'RUPEE INDIA',
    'PESO COLOMBIANO',
    'PESO ARGENTINA',
  ];

  private mxnForeignExchanges: string[] = [
    'PESO MXN',
    'EURO',
    'POUND',
    'YEN',
    'REAL',
    'CANADA DLL',
  ];

  private mxnForeignExchangeNames: string[] = [
    'DOLAR USD',
    'EURO',
    'LIBRA',
    'YEN',
    'REAL',
    'DOLAR CANADIENSE',
  ];

  private mxnAlwaysVisible: string[] = ['PESO MXN', 'EURO', 'POUND', 'YEN'];

  private mxnAlwaysVisibleNames: string[] = [
    'USD/MXN',
    'EUR/MXN',
    'GBP/MXN',
    'JPY/MXN',
  ];

  private currencySymbolCharacters: string[] = [
    '&#x24;',
    '&euro;',
    '&yen;',
    '&#x24;',
    '&dollar;',
  ];

  private indexSolaceSubscription: Subscription;

  constructor(
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
    private marketService: MarketService,
    private sharedSolaceStreamService: SharedSolaceStreamService,
  ) {}

  ngOnInit() {
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.store
        .select('marketOperationTime')
        .pipe(
          map((value: any) => value.toJS()),
          take(1),
        )
        .subscribe((value: any) => {
          this.operationTime = value;
          this._setForeignExchangesData();
        });
    });
  }

  ngOnDestroy() {
    this.disposeIndexesRows();

    if (this.indexSubscription) {
      this.indexSubscription.unsubscribe();
    }

    this.removeIndexSolaceSubscription();
  }

  changeCurrentIndex(index: string): void {
    this.currentIndex = index;
  }

  private removeIndexSolaceSubscription(): void {
    if (this.indexSolaceSubscription) {
      this.indexSolaceSubscription.unsubscribe();
      this.sharedSolaceStreamService.removeConsumerFromObservable(
        this.currentIndex,
        this.marketName,
        this.consumerId,
      );
    }
  }

  private disposeIndexesRows(): void {
    for (const index of this.foreignexchangesMXN) {
      index.dispose();
    }
    if (this.mxnReferences !== undefined) {
      this.mxnReferences.dispose();
      this.mxnReferences.length = 0;
    }

    this.foreignexchangesMXN.length = 0;
  }

  private _setForeignExchangesData() {
    const WAIT_TIME = 150;
    const ELEMENTS_LIST = 5;

    if (
      this.sharedSolaceStreamService.markets.currencies.length >= ELEMENTS_LIST
    ) {
      this.setForeignExchangesData();
    } else {
      setTimeout(() => {
        this._setForeignExchangesData();
      }, WAIT_TIME);
    }
  }

  private setForeignExchangesData(): void {
    this.disposeIndexesRows();

    this.skeleton = false;

    const leftColumn: number = this.usdForeignExchangeNames.length / 2;

    this.mxnReferences = new ForeignExchangeRow(
      this.sharedSolaceStreamService,
      this.mainMxnReferences,
    );
    // MXN
    for (let index = 0; index < this.mxnForeignExchangeNames.length; index++) {
      this.foreignexchangesMXN.push(
        new ForeignExchangeRow(
          this.sharedSolaceStreamService,
          this.mxnForeignExchanges[index],
          this.mxnReferences,
          'mxn',
        ),
      );
      this.foreignexchangesMXN[index].currencySymbol =
        this.currencySymbolCharacters[0];
      this.foreignexchangesMXN[index].realName =
        this.mxnForeignExchangeNames[index];
    }

    // USD
    for (let index = 0; index < this.usdForeignExchangeNames.length; index++) {
      this.foreignexchangesUSD.push(
        new ForeignExchangeRow(
          this.sharedSolaceStreamService,
          this.usdForeignExchanges[index],
          this.mxnReferences,
          'usd',
        ),
      );
      this.foreignexchangesUSD[index].currencySymbol =
        this.currencySymbolCharacters[4];
      this.foreignexchangesUSD[index].realName =
        this.usdForeignExchangeNames[index];

      if (index < leftColumn) {
        this.foreignexchangesUSDLeft.push(this.foreignexchangesUSD[index]);
      } else {
        this.foreignexchangesUSDRight.push(this.foreignexchangesUSD[index]);
      }
    }

    for (let index = 0; index < this.mxnAlwaysVisibleNames.length; index++) {
      this.foreignexchangesMXNAlways.push(
        new ForeignExchangeRow(
          this.sharedSolaceStreamService,
          this.mxnAlwaysVisible[index],
          this.mxnReferences,
        ),
      );
      this.foreignexchangesMXNAlways[index].currencySymbol =
        this.currencySymbolCharacters[0];
      this.foreignexchangesMXNAlways[index].realName =
        this.mxnAlwaysVisibleNames[index];
    }

    if (this.foreignexchange === 'mxn') {
      this.foreignexchanges = this.foreignexchangesMXN;
    } else if (this.foreignexchange === 'usdLeft') {
      this.foreignexchanges = this.foreignexchangesUSDLeft;
    } else if (this.foreignexchange === 'usdRight') {
      this.foreignexchanges = this.foreignexchangesUSDRight;
    } else {
      this.foreignexchanges = this.foreignexchangesMXNAlways;
    }
  }
}
